import { Fade, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { Channel } from '../../types/channel'
import ChannelRowMobile from './ChannelRowMobile'
import UserRowMobileSkeleton from './ChannelRowMobile.skeleton'
import useStyles from './styles/ChannelsTable.styles'

interface ChannelListProps {
  data: Channel[]
  loading: boolean
}
export const ChannelsTableMobile: React.FC<ChannelListProps> = ({
  data,
  loading
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.tableHeadMobile}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Code')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton onClick={() => {}}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>

      {loading
        ? Array(6)
            .fill('')
            .map((item, index) => (
              <UserRowMobileSkeleton
                key={`channel-skeleton${item}${index.toString()}`}
              />
            ))
        : data?.map((singleChannel) => (
            <Fade
              in
              timeout={600}
              key={singleChannel.basicDetails.displayChannelCode}>
              <div>
                <ChannelRowMobile
                  key={singleChannel.basicDetails.displayChannelCode}
                  data={singleChannel}
                />
              </div>
            </Fade>
          ))}
    </div>
  )
}
